module.exports = __webpack_public_path__ + "static/media/crow.3e8cb08c.jpg";